var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.hotsitem),function(item,index){return _c('div',{key:index,staticClass:"custom-hot_item",style:(_vm.getCustomStyle(item)),on:{"click":function($event){$event.stopPropagation();return _vm.actionHandler(item.action)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }